import AuthService from '../../state/auth.service';
import axios from 'axios';

import endpoints from '../endpoints';

const getHeaders = () => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `${AuthService.getToken()}`,
    };
};

export default {
    fetchLogs(filters) {
        return axios
            .post(endpoints.ACTIVITY_LOGS, filters, {
                headers: getHeaders(),
            })
            .then(response => {
                return response.data;
            }).catch(err => {
                let message = `Error fetching logs...`;
                if (err && err.response && err.response.data) {
                    message = err.response.data.message;
                }
                throw message;
            });
    },
};
